import React, { Component } from 'react';
import Button from "../elements/Buttons";
import { CloseBotSvg } from '../utils/svg-icons-24';

class ChatHeader extends Component{
    constructor(props){
        super(props);
    }
    render(){
        const {language, englishTitle, arabicTitle, headerStatus, isServiceBusy, minimizeAction} = this.props;
        const isBusy = isServiceBusy;
        return(
            <div className="chat-header current first-box trans">

                <div className="avatars-wrapper operators-avatar-1">
                    <div className="header-ava"></div>
                </div>
                
                <h2 className="online">
                    <span>{englishTitle}</span>
                    <span>{arabicTitle}</span>
                    <i className='status-icon'>
                        <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {headerStatus===true?(
                                <circle cx="3.5" cy="3.5" r="3.5" fill="#37C43A" />
                            ):(
                                <circle cx="3.5" cy="3.5" r="3.5" fill="#cccccc" />
                            )}                            
                        </svg>
                    </i>
                </h2>
                
                {/* {this.props.isLanguageBtn && this.props.isLanguageBtn===true && this.props.headerStatus===true?(
                    this.props.language==='ar'?(
                        <Button
                            id="langEnBtn"
                            type="button"
                            classes="material-icons options ripple color-white languageBtn"
                            title="English"
                            action={this.props.languageAction}
                            areaLabel="English"
                            svg="false"
                            disabled={isBusy}
                        >
                            English
                        </Button>
                    ):(
                        <Button
                            id="langArBtn"
                            type="button"
                            classes="material-icons options ripple color-white languageBtn"
                            title="عربي"
                            action={this.props.languageAction}
                            areaLabel="عربي"
                            svg="false"
                            disabled={isBusy}
                        >
                            عربي
                        </Button>
                    )
                                        
                ):(null)} */}

                <Button
                    type="button"
                    classes="material-icons exit-chat ripple color-white material-close-icons"
                    title={language==="ar"? "إغلاق": "Close"}
                    action={minimizeAction}
                    areaLabel={language==="ar"? "إغلاق": "Close"}
                    svg="true"
                >
                    <CloseBotSvg />
                </Button>

            </div>
        )
    }
}
ChatHeader.propTypes = {
    isAgent: React.propTypes.node,
    speakerAction: React.propTypes.node,
    isSpeaker: React.propTypes.node,
    minimizeAction: React.propTypes.node,
    arabicTitle: React.propTypes.node,
    englishTitle: React.propTypes.node,
    languageAction: React.propTypes.node,
    language: React.propTypes.node,
    isLanguageBtn: React.propTypes.node,
}
export default ChatHeader;